/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import SectionTitle from 'components/Common/SectionTitle'
import ToolTip from 'components/Common/ToolTip'
import VaultSummary from './VaultSummary'

const VaultSummaryContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxHeight: '450px',
  overflowY: 'auto',
}))

const VaultCard = props => {
  const tooltipContent = (
    <Typography variant="body2" color="white">
      Alerts for Compliance, Monitoring, Business Changes about the Enterprises business.
    </Typography>
  )

  return (
    <Box
      sx={{
        height: '100%',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          gap: 1.25,
          padding: '25px',
        }}
      >
        <Box>
          <SectionTitle title="Alerts" />
          &nbsp;
          <ToolTip content={tooltipContent} />
        </Box>

        <VaultSummaryContainer>
          <VaultSummary />
        </VaultSummaryContainer>
      </Box>
    </Box>
  )
}

export default VaultCard
